import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { CarouselItemStyle, TutoStepContent } from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [SafePipe, VariableReplacementPipe],
})
export class Variant1Component extends BaseComponent {
  itemStyle = input.required<CarouselItemStyle>();
  stepContent = input.required<TutoStepContent>();

  public maxSelectedChallenges: number = this.environment.maxSelectedChallenges;
}
